export default {

  // 新增发票
  insertYcInvoice: '/ygsjzs/ycnInvoice/insertYcnInvoice',

  // 修改发票
  updateYcInvoice: '/ygsjzs/ycnInvoice/updateYcnInvoice',

  // 上传发票
  addYcInvoice: '/ygsjzs/ycnInvoice/addYcnInvoice',

  // 删除发票
  deleteYcInvoice: '/ygsjzs/ycnInvoice/deleteDataYcnInvoice',
  // 查询发票详情
  selectYcInvoiceByInvoiceId: '/ygsjzs/ycnInvoice/selectYcnInvoiceByInvoiceId',
  // 查询发票列表
  selectYcInvoiceByPage: '/ygsjzs/ycnInvoice/selectYcnInvoiceByPage'
}
